import type { Ref, FC } from 'react';
import { HTMLAttributes } from 'react';
import c from 'classnames';
import s from './RightSideButtonWrapper.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  isCollapsed?: boolean;
  innerRef?: Ref<HTMLDivElement>;
}

const RightSideButtonWrapper: FC<Props> = ({
  isCollapsed,
  innerRef,
  className,
  ...rest
}) => (
  <div
    ref={innerRef}
    className={c(s['root'], isCollapsed && s['collapsed'], className)}
    {...rest}
  />
);
RightSideButtonWrapper.displayName = 'RightSideButtonWrapper';

export default RightSideButtonWrapper;
